import { select } from "redux-saga/effects";

import { history } from "state/history";
import { getMessageByID } from "state/teachers/selectors";

export default function* goToMessageSaga(action) {
  const { messageID } = action.payload;
  const message = yield select(getMessageByID, messageID);
  const { schoolID } = message.toObject();
  history.push(`/teachers/messages/${schoolID}/`);
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/goToMessageSaga.js